import axios from 'axios';
export const isValidSession = async (): Promise<boolean> => {
	return await axios.get('/auth/check-cookie', { withCredentials: true })
		.then(() => Promise.resolve(true))
		.catch(() => Promise.resolve(false));
};
